import React from 'react';
import { LectorTemas } from '../components/cursos/LectorTemas';
import { LECTOR_SAMPLE } from '../data/lectorTemasSample';

export default function LectorTemasPreview() {
  return (
    <LectorTemas
      courseTitle="⚓ Curso: Legislación Naval 2026"
      moduleLabel="Módulo 1 · Fundamentos Legales"
      lessons={LECTOR_SAMPLE}
    />
  );
}
